import React, { useEffect, useState } from "react";
import "./FestivalPostList.scss";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import toast from "react-hot-toast";
import { CommonEnums } from "../../../../../enums/common.enums";
import { PropertyApi } from "../../../../../utils/api/Property";
import ProtectedComponent from "../../../../../components/ProtectedComponent";
import NavigationLayout from "../../../navigation";
import BackArrowIcon from "../../../../../components/icons/BackArrowIcon";
import SceduleAuctionListFilter from "../../openhome/SceduleAuctionListFilter";
import FacebookIcon from "../../../../../components/icons/FacebookIcon";
import InstagramIcon from "../../../../../components/icons/InstagramIcon";
import LinkedInIcon from "../../../../../components/icons/LinkedInIcon";
import GoogleBusinessIcon from "../../../../../components/icons/GoogleBusinessIcon";
import YouTubeIcon from "../../../../../components/icons/YouTubeIcon";
import TikTokIcon from "../../../../../components/icons/TikTokIcon";
import AuctionListMenuIcon from "../../../workspaceShedule/AuctionListMenuIcon";
import AuctionListFilter from "../../../workspaceShedule/AuctionListFilter";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ReviewPostListFilter from "./FestivalListFilter";
import ReviewPostFilter from "../filter/FestivalPostFilter";
import { TemplatesApi } from "../../../../../utils/api/Templates";
import Loading from "../../../../loading/Loading";
import { clientRoutes } from "../../../../../utils/routes";
import CustomPageLoader from "../../../../../components/loaders/CustomPageLoader";
import { CommonHelpers } from "../../../../../utils/helpers/common.helpers";
import ReviewListManuIcon from "./FestivalListManuIcon";
import PreviewModal from "../../propertypost/view/PreviewModal";
import PaginationButton from "./PaginationButton";
import AnnouncementListFilter from "./FestivalListFilter";
import AnnouncementListManuIcon from "./FestivalListManuIcon";
import AnnouncementPostFilter from "../filter/FestivalPostFilter";
import FestivalListManuIcon from "./FestivalListManuIcon";
import FestivalPostFilter from "../filter/FestivalPostFilter";
import FestivalListFilter from "./FestivalListFilter";
import { getImageUrl } from "../../../../../utils/helpers/common";
dayjs.extend(isBetween);

interface StateType {
  isLoading: boolean;
  totalPage: number;
  pageNumber: number;
  listData: Record<string, any[]>;
  search: string;
}

type FilterType = {
  year: number;
  month: number | null;
  start_date?: string;
  end_date?: string;
  property_id?: string;
  post_status?: string;
  post_type?: string;
  festival_type?: string;
  search?: string;
  agent_ref?: string;
  agents_id?: string;
  agency_ref?: string;
} | null;

const ImageRenderer = ({
  src,
  fallbackSrc,
  alt,
  className,
}: {
  src: string;
  fallbackSrc: string;
  alt: string;
  className?: string;
}) => {
  const [currentSrc, setCurrentSrc] = useState(fallbackSrc);

  useEffect(() => {
    const imageToLoad = new Image();
    imageToLoad.src = src;

    imageToLoad.onload = () => {
      setCurrentSrc(src);
    };

    imageToLoad.onerror = () => {
      setCurrentSrc(fallbackSrc);
    };
  }, [src, fallbackSrc]);

  return <img src={currentSrc} alt={alt} className={className} />;
};

const AgencyFestivalPostList = () => {
  const [state, setState] = useState<StateType>({
    isLoading: false,
    totalPage: 1,
    pageNumber: 1,
    listData: {},
    search: "",
  });

  const [filter, setFilter] = useState<FilterType>(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [refreshingIds, setRefreshingIds] = useState<string[]>([]);
  const [counters, setCounters] = useState<Record<string, number>>({});
  const [previewItem, setPreviewItem] = useState<any | null>(null);
  const [festivalTypeMap, setFestivalTypeMap] = useState<
    Record<string, string>
  >({});
  const subscriptionType =
    searchParams.get("subscription_type") || "agent_marketing";

  const getFestivalList = async (page: number, search: string) => {
    const params: Record<string, any> = {};

    let agents_id = searchParams.get(CommonEnums.queryParams?.agent_id);

    // From URL params
    const property_id =
      searchParams.get(CommonEnums.queryParams.activitiesFilter.property_id) ||
      "";

    const festival_type =
      searchParams.get(
        CommonEnums.queryParams.activitiesFilter.festival_type
      ) || "";

    const start_date_param =
      searchParams.get(CommonEnums.queryParams.activitiesFilter.start_date) ||
      "";
    const end_date_param =
      searchParams.get(CommonEnums.queryParams.activitiesFilter.end_date) || "";
    const post_status =
      searchParams.get(CommonEnums.queryParams.activitiesFilter.post_status) ||
      "";
    const post_type =
      searchParams.get(CommonEnums.queryParams.activitiesFilter.post_type) ||
      "";

    if (property_id) params.property_id = property_id;
    if (agents_id) params.agents_id = agents_id;
    if (post_status) params.post_status = post_status;
    if (festival_type) params.festival_type = festival_type;
    if (post_type) params.post_type = post_type;

    // From filter state
    if (filter?.property_id) params.property_id = filter.property_id;
    if (filter?.agents_id) params.agents_id = filter.agents_id;
    if (filter?.post_status) params.post_status = filter.post_status;
    if (filter?.festival_type) params.festival_type = filter.festival_type;
    if (filter?.post_type) params.post_type = filter.post_type;
    if (filter?.month !== null && filter?.year) {
      params.start_date = dayjs()
        .year(filter.year)
        .month(filter.month as number)
        .startOf("month")
        .format("YYYY-MM-DD");

      params.end_date = dayjs()
        .year(filter.year)
        .month(filter.month as number)
        .endOf("month")
        .format("YYYY-MM-DD");
    } else {
      if (start_date_param) params.start_date = start_date_param;
      if (end_date_param) params.end_date = end_date_param;
    }

    setState((prev) => ({ ...prev, isLoading: true }));

    const res = await PropertyApi.GetFestivalPosts(params);

    if (res.data?.success) {
      let allData = res.data.data?.docs || res.data.data;

      // allData = allData.filter((item: any) => item.post_status !== "trash");

      allData.sort(
        (a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );

      const grouped = allData.reduce((acc: any, item: any) => {
        const formattedDate = dayjs(item.auction_date).format("Do MMMM, YYYY");
        if (!acc[formattedDate]) acc[formattedDate] = [];
        acc[formattedDate].push(item);
        return acc;
      }, {});

      const newCounters: Record<string, number> = {};
      allData.forEach((item: any) => {
        if (item.post_status === "processing") {
          newCounters[item._id] = 5;
        }
      });

      setState((prev) => ({
        ...prev,
        isLoading: false,
        listData: grouped,
        totalPage: res.data.data?.totalPages || 1,
      }));

      setCounters(newCounters);
    } else {
      toast.error(res?.error || "Failed to fetch auctions.");
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  const onClickPreview = () => {
    setState((prev) => ({
      ...prev,
      pageNumber: Math.max(prev.pageNumber - 1, 1),
    }));
  };

  const onClickNext = () => {
    setState((prev) => ({
      ...prev,
      pageNumber: Math.min(prev.pageNumber + 1, prev.totalPage),
    }));
  };

  useEffect(() => {
    setState((prev) => ({ ...prev, pageNumber: 1 }));
  }, [filter]);

  useEffect(() => {
    getFestivalList(state.pageNumber, state.search);
  }, [state.search, state.pageNumber, searchParams, filter]);

  const capitalizeFirstLetter = (str: string) => {
    if (!str) return "-";
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const refreshSingleItem = async (id: string) => {
    try {
      setRefreshingIds((prev) => [...prev, id]);
      setCounters((prev) => ({ ...prev, [id]: 5 }));

      const res = await PropertyApi.GetFestivalPostById(id);

      if (res.data?.success) {
        const updatedItem = res.data.data;

        if (updatedItem.post_status === "cancelled") {
          setCounters((prev) => {
            const newCounters = { ...prev };
            delete newCounters[id];
            return newCounters;
          });
        }

        setState((prev) => {
          const newListData: Record<string, any[]> = { ...prev.listData };
          for (const date in newListData) {
            newListData[date] = newListData[date].map((it: any) =>
              it._id === id ? updatedItem : it
            );
          }
          return { ...prev, listData: newListData };
        });
      }
    } catch (error) {
      console.error("Refresh failed", error);
    } finally {
      setRefreshingIds((prev) => prev.filter((x) => x !== id));
    }
  };

  const RefreshCountdown = ({
    id,
    counter,
    refreshInterval = 5,
    onRefresh,
  }: {
    id: string;
    counter: number;
    refreshInterval?: number;
    onRefresh: (id: string) => void;
  }) => {
    return (
      <div className="refresh-countdown">
        Refreshing record in {counter} seconds …{" "}
        <button
          type="button"
          className="refresh-now-btn"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onRefresh(id);
          }}
        >
          Refresh Now
        </button>
      </div>
    );
  };

  useEffect(() => {
    if (Object.keys(counters).length === 0) return;

    const timer = setInterval(() => {
      setCounters((prev) => {
        const newCounters: Record<string, number> = { ...prev };

        Object.keys(prev).forEach((id) => {
          const current = prev[id] ?? 5;
          if (current === 1) {
            refreshSingleItem(id);
            newCounters[id] = 5;
          } else {
            newCounters[id] = current - 1;
          }
        });

        return newCounters;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [counters]);

  const renderDesignImage = ({ item }: { item: any }) => {
    const showAgentInfo = item.user_type === "agent";
    const AgentInfo = showAgentInfo ? (
      <div className="agent-info">
        <img
          src={
            getImageUrl(
              item?.agent_ref?.profile_image_ref?.compressed_file_path || ""
            ) || "/images/profile-placeholder-image.png"
          }
          alt="Agent"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = "/images/profile-placeholder-image.png";
          }}
        />
        <div>
          <p>
            {item.agent_ref?.principal_agent_first_name}{" "}
            {item.agent_ref?.principal_agent_last_name}
          </p>
          <p>
            {item.agent_ref?.principal_phone_country_code}{" "}
            {item.agent_ref?.principal_agent_mobile_number}
          </p>
        </div>
      </div>
    ) : null;

    const fallbackUrl = "/images/square-fallback-image-for-image-preview.png";
    const fallbackCancelled =
      "/images/image-video-generation-error-fallback-image-for-card.png";
    const designActivityRef = item.image_post_design_activity_ref?._id
      ? item.image_post_design_activity_ref
      : item.story_post_design_activity_ref?._id
      ? item.story_post_design_activity_ref
      : item.video_post_design_activity_ref?._id
      ? item.video_post_design_activity_ref
      : item.reel_post_design_activity_ref;

    const refStatus = designActivityRef?.post_status || item.post_status;
    const postType = designActivityRef?.design_post_type || item.post_type;
    const assetUrlRaw = designActivityRef?.design_task_id?.output_image_path;
    const assetUrl = assetUrlRaw
      ? CommonHelpers.getImageUrlFromImageTool({ path: assetUrlRaw })
      : null;

    console.log("assetUrl:", assetUrl);

    if (refStatus === "cancelled") {
      return (
        <div className="activity-image-section">
          <ImageRenderer
            src={assetUrl || fallbackCancelled}
            fallbackSrc={fallbackUrl}
            alt="Cancelled"
            className="activity-thumbnail"
          />
          {AgentInfo}
        </div>
      );
    }

    if (refStatus === "processing") {
      return (
        <div className="activity-image-section image-placeholder-container">
          <div className="loader-container">
            <CustomPageLoader className="activity-card-loader" />
            <p className="processing-text font-poppins-400">Processing...</p>
          </div>
        </div>
      );
    }

    if (refStatus === "pending_for_social_media_upload") {
      if (postType === CommonEnums.postType.story_post.key) {
        return (
          <div className="activity-image-section story-post-image-container">
            <ImageRenderer
              src={assetUrl || fallbackUrl}
              fallbackSrc={fallbackUrl}
              alt="Property"
              className="activity-thumbnail"
            />
            {AgentInfo}
          </div>
        );
      }

      if (postType === CommonEnums.postType.video_post.key) {
        return (
          <div className="activity-image-section video-placeholder-collection">
            <ImageRenderer
              src={assetUrl || fallbackUrl}
              fallbackSrc={fallbackUrl}
              alt="Property"
              className="activity-thumbnail"
            />
            {AgentInfo}
          </div>
        );
      }

      if (postType === CommonEnums.postType.reel_post.key) {
        return (
          <div className="activity-image-section reel-placeholder-collection">
            <ImageRenderer
              src={assetUrl || fallbackUrl}
              fallbackSrc={fallbackUrl}
              alt="Property"
              className="activity-thumbnail"
            />
            {AgentInfo}
          </div>
        );
      }

      return (
        <div className="activity-image-section">
          <ImageRenderer
            src={assetUrl || fallbackUrl}
            fallbackSrc={fallbackUrl}
            alt="Property"
            className="activity-thumbnail"
          />
          {AgentInfo}
        </div>
      );
    }

    return (
      <div className="activity-image-section image-placeholder-container">
        <img
          src={
            assetUrl ||
            "/images/image-video-generation-error-fallback-image-for-card.png"
          }
          alt="Property"
          className="activity-thumbnail"
          onError={(e: any) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src =
              "/images/image-video-generation-error-fallback-image-for-card.png";
          }}
        />
        {AgentInfo}
      </div>
    );
  };

  function formatPostStatus(status?: string): string {
    if (!status) return "-";
    return status
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const getPostStatusDisplay = (item: any) => {
    if (item.post_status === "cancelled") return "Cancelled";
    if (item.post_status === "processing") return "Processing...";
    if (item.post_status === "pending_for_social_media_upload")
      return "Pending Upload";

    const scheduleDatetime = item.schedule_datetime
      ? item.schedule_datetime.$date
        ? new Date(item.schedule_datetime.$date)
        : new Date(item.schedule_datetime)
      : null;

    if (scheduleDatetime) return "Scheduled to Post";

    return formatPostStatus(item.post_status || "-");
  };

  const getPreviewImages = (item: any): string[] => {
    const refs = [
      item.image_post_design_activity_ref,
      item.story_post_design_activity_ref,
      item.video_post_design_activity_ref,
      item.reel_post_design_activity_ref,
    ].filter(Boolean);

    return refs
      .map((ref: any) =>
        ref?.design_task_id?.output_image_path
          ? CommonHelpers.getImageUrlFromImageTool({
              path: ref.design_task_id.output_image_path,
            })
          : null
      )
      .filter(Boolean) as string[];
  };

  useEffect(() => {
    const fetchFestivalTypes = async () => {
      try {
        const res = await TemplatesApi.getFestivalTypes({
          search: "",
          page: 1,
          limit: 200,
          created_at: "desc",
        });

        if (res?.data?.success) {
          const list = res.data.data?.docs || res.data.data || [];

          const map: Record<string, string> = {};
          list.forEach((item: any) => {
            if (item.slug && item.name) {
              map[item.slug] = item.name;
            }
          });

          setFestivalTypeMap(map);
        }
      } catch (error) {
        console.error("Failed to fetch festival types", error);
      }
    };

    fetchFestivalTypes();
  }, []);

  const formatFestivalName = (str: string) => {
    if (!str) return "";
    return str.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const getFestivalNameBySlug = (slug?: string) => {
    if (!slug) return "-";
    return festivalTypeMap[slug] || formatFestivalName(slug);
  };

  return (
    <ProtectedComponent>
      <NavigationLayout>
        <div className="festival-list-container">
          <div className="manage-invites-list-heading">
            <div
              className="propertie-view-back-btn"
              onClick={() => navigate(clientRoutes.workspace)}
            >
              <div className="back-icon">
                <BackArrowIcon />
              </div>
              <p className="bakc-text-contain">Back to Workspace</p>
            </div>
            <p className="heading-text">Festival Posts</p>
          </div>

          <FestivalListFilter
            onChange={(val) => {
              if (val) {
                setFilter({
                  year: val.year,
                  month: val.month,
                  start_date: dayjs()
                    .year(val.year)
                    .month(val.month!)
                    .startOf("month")
                    .format("YYYY-MM-DD"),
                  end_date: dayjs()
                    .year(val.year)
                    .month(val.month!)
                    .endOf("month")
                    .format("YYYY-MM-DD"),
                });
              } else {
                setFilter(null);
              }
            }}
            onClickRefresh={() =>
              getFestivalList(state.pageNumber, state.search)
            }
            rightAction={
              <button
                className="send-invite-btn"
                onClick={() =>
                  navigate(
                    `/workspace/agency-create-festival-post?subscription_type=${subscriptionType}`
                  )
                }
              >
                Create New
              </button>
            }
          />

          {state?.isLoading ? (
            <div className="list-page-loading">
              <Loading />
            </div>
          ) : Object.entries(state.listData).length === 0 ? (
            <div className="data-not-found">
              <p>List is empty!</p>
            </div>
          ) : (
            <div className="responsive-grid-container">
              {Object.entries(state.listData)
                .sort(
                  ([dateA], [dateB]) =>
                    dayjs(dateA, "Do MMMM, YYYY").toDate().getTime() -
                    dayjs(dateB, "Do MMMM, YYYY").toDate().getTime()
                )
                .map(([date, auctions]) => (
                  <React.Fragment key={date}>
                    {/* <div className="filter-date">{date}</div> */}
                    {auctions.map((item) => (
                      <div key={item._id} className="activities-card-wrapper">
                        <Link
                          to={`/workspace/agency-festival-post/view/${item._id}?subscription_type=${subscriptionType}`}
                          className="activity-card-link"
                        >
                          <div className="activity-card">
                            {/* <div className="activity-image-section">
                            <img
                              src={
                                item.design_template_id?.template_image ||
                                "/images/image-video-generation-error-fallback-image-for-card.png"
                              }
                              alt="Template"
                              className="activity-thumbnail"
                              onError={(
                                e: React.SyntheticEvent<HTMLImageElement, Event>
                              ) => {
                                const target = e.currentTarget;
                                target.onerror = null;
                                target.src =
                                  "/images/image-video-generation-error-fallback-image-for-card.png";
                              }}
                            />
                          </div> */}

                            {renderDesignImage({ item })}

                            <div className="activity-content-section">
                              <div
                                className="activity-options-menu"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                              >
                                <FestivalListManuIcon
                                  postId={item?._id}
                                  onUpdated={() =>
                                    getFestivalList(
                                      state.pageNumber,
                                      state.search
                                    )
                                  }
                                  onViewDetails={() =>
                                    navigate(
                                      `/workspace/agency-festival-post/view/${item._id}?subscription_type=${subscriptionType}`
                                    )
                                  }
                                  onPreview={() => {
                                    setPreviewItem(item);
                                    setIsPreviewOpen(true);
                                  }}
                                  previewImageUrl={getPreviewImages(item)[0]}
                                />
                              </div>

                              <div className="activity-details">
                                <div className="detail-row">
                                  <div>
                                    <div className="label">Scheduled On</div>
                                    <div className="value">
                                      {item.schedule_datetime
                                        ? dayjs(item.schedule_datetime).format(
                                            "MMM DD, YYYY hh:mm A"
                                          )
                                        : "-"}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="label">Current Status</div>
                                    <div className="value">
                                      {getPostStatusDisplay(item)}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="label">Festival type</div>
                                    <div className="value">
                                      {getFestivalNameBySlug(item.festival_type)}
                                    </div>
                                  </div>
                                </div>

                                <div className="detail-row">
                                  <div>
                                    <div className="label">Post</div>
                                    <div className="value">
                                      {capitalizeFirstLetter(item.post_type)}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="label">Template</div>
                                    <div className="value">
                                      {item?.image_post_design_activity_ref
                                        ?.design_template_id?.name ||
                                        item?.story_post_design_activity_ref
                                          ?.design_template_id?.name ||
                                        item?.video_post_design_activity_ref
                                          ?.design_template_id?.name ||
                                        item?.reel_post_design_activity_ref
                                          ?.design_template_id?.name ||
                                        "-"}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="label">Created on</div>
                                    <div className="value">
                                      {dayjs(item.createdAt).format(
                                        "MMM DD, YYYY hh:mm A"
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="detail-row">
                                  <div>
                                    <div className="label">Last Updated on</div>
                                    <div className="value">
                                      {dayjs(item.updatedAt).format(
                                        "MMM DD, YYYY hh:mm A"
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {item.post_status === "processing" && (
                                <div
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }}
                                >
                                  <RefreshCountdown
                                    id={item._id}
                                    counter={counters[item._id] ?? 5}
                                    refreshInterval={5}
                                    onRefresh={refreshSingleItem}
                                  />
                                </div>
                              )}

                              <div className="activity-social-icons">
                                <FacebookIcon />
                                <InstagramIcon />
                                <LinkedInIcon />
                                <GoogleBusinessIcon />
                                <YouTubeIcon />
                                <TikTokIcon />
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </React.Fragment>
                ))}
            </div>
          )}

          <FestivalPostFilter />

          <PaginationButton
            total_page={state.totalPage}
            page_number={state.pageNumber}
            onClickNext={onClickNext}
            onClickPreview={onClickPreview}
            is_loading={state.isLoading}
          />

          {isPreviewOpen && previewItem && (
            <PreviewModal
              open={isPreviewOpen}
              onClose={() => setIsPreviewOpen(false)}
              images={
                [
                  previewItem?.image_post_design_activity_ref?.design_task_id
                    ?.output_image_path
                    ? CommonHelpers.getImageUrlFromImageTool({
                        path: previewItem.image_post_design_activity_ref
                          .design_task_id.output_image_path,
                      })
                    : null,
                  previewItem?.story_post_design_activity_ref?.design_task_id
                    ?.output_image_path
                    ? CommonHelpers.getImageUrlFromImageTool({
                        path: previewItem.story_post_design_activity_ref
                          .design_task_id.output_image_path,
                      })
                    : null,
                  previewItem?.video_post_design_activity_ref?.design_task_id
                    ?.output_image_path
                    ? CommonHelpers.getImageUrlFromImageTool({
                        path: previewItem.video_post_design_activity_ref
                          .design_task_id.output_image_path,
                      })
                    : null,
                  previewItem?.reel_post_design_activity_ref?.design_task_id
                    ?.output_image_path
                    ? CommonHelpers.getImageUrlFromImageTool({
                        path: previewItem.reel_post_design_activity_ref
                          .design_task_id.output_image_path,
                      })
                    : null,
                ].filter(Boolean) as string[]
              }
              initialIndex={0}
            />
          )}
        </div>
      </NavigationLayout>
    </ProtectedComponent>
  );
};

export default AgencyFestivalPostList;
